import theme from "../../../../constants/theme";
export const Style = {
  katildiniz: {
    color: theme.COLORS.green,
    fontSize: 15,
    marginRight: 15,
  },
};
